import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { money } from "@/lib/site";
import { iconFor } from "./common";

export const BuyButton = ({ pkg, className = "", label = "Pay now", testid }) => (
  <Link to={`/checkout/${pkg.id}`} data-testid={testid || `service-pay-now-${pkg.id}`}
    className={`inline-flex items-center justify-center gap-1.5 rounded-full bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 text-sm font-semibold transition-colors ${className}`}>
    {label} <ArrowUpRight className="w-4 h-4" />
  </Link>
);

export const PriceCard = ({ pkg, featured }) => {
  const Icon = iconFor(pkg.id);
  return (
    <div className={`group relative flex flex-col rounded-3xl p-7 border transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_rgba(15,23,42,0.10)] ${featured ? "bg-[#090D16] text-white border-transparent" : "bg-white border-slate-200"}`} data-testid={`pricing-card-${pkg.id}`}>
      {featured && <span className="absolute -top-3 left-7 rounded-full bg-[#FF5733] text-white text-[11px] font-mono uppercase tracking-widest px-3 py-1">Most chosen</span>}
      <Icon className={`w-6 h-6 ${featured ? "text-sky-400" : "text-blue-600"}`} />
      <h3 className="mt-5 font-display text-xl font-bold tracking-tight">{pkg.name}</h3>
      <p className={`mt-1 text-sm ${featured ? "text-slate-400" : "text-slate-500"}`}>{pkg.tagline}</p>
      <p className="mt-6 font-display text-4xl font-extrabold tracking-tight" data-testid={`pricing-price-${pkg.id}`}>
        {money(pkg.price)}<span className={`text-sm font-medium ml-1 ${featured ? "text-slate-400" : "text-slate-500"}`}>USD</span>
      </p>
      <p className={`text-xs mt-1 ${featured ? "text-slate-500" : "text-slate-400"}`}>Starting price · one-time</p>
      <ul className="mt-6 space-y-2.5 flex-1">
        {pkg.features.map((f) => (
          <li key={f} className={`flex gap-2.5 text-sm ${featured ? "text-slate-300" : "text-slate-600"}`}><Check className="w-4 h-4 mt-0.5 shrink-0 text-emerald-500" />{f}</li>
        ))}
      </ul>
      {pkg.note && <p className={`mt-5 text-xs ${featured ? "text-slate-500" : "text-slate-400"}`}>{pkg.note}</p>}
      <div className="mt-6 flex flex-col gap-2">
        <BuyButton pkg={pkg} testid={`pricing-pay-now-btn-${pkg.id}`} />
        <Link to={`/services/${pkg.id}`} className={`text-center text-sm py-2 rounded-full transition-colors ${featured ? "text-slate-300 hover:text-white" : "text-slate-600 hover:text-blue-600"}`} data-testid={`pricing-details-${pkg.id}`}>See details</Link>
      </div>
    </div>
  );
};
